/** @jsx jsx */
import { jsx } from '@emotion/react';
import { Fragment } from 'react';
import { BrandButton } from '@zapier/design-system';
import { emitUserInteractionEvent } from '../../utils/avroEvents';
import { labelStyles } from '@zapier/style-encapsulation';
import { loginPath, signupPath } from '../../constants';
import { useUniversalNavContext } from '../../hooks';

import UniversalTopbarLink from './UniversalTopbarLink';

type Props = {
  /**
   * `Href` to login button.
   */
  loginHref?: string;
  /**
   * Currently navigated to url.
   * @deprecated
   */
  selectedHref?: string;
  /**
   * Indicates whether Log in button should render.
   */
  shouldRenderSignIn: boolean;
  /**
   * Indicates whether Sign up button should render.
   */
  shouldRenderSignUp: boolean;
  /**
   * The size of the component, which influences the size of its buttons.
   * @deprecated
   */
  size?: 'small' | 'medium';
  /**
   * `Href` to signup button.
   */
  signupHref?: string;
};

const Styles = labelStyles('AccountActions', {
  signupButton: {
    minWidth: 100,
  },
});

/**
 * @private
 * Conditionally renders a login link and sign up button.
 */
export const AccountActions = ({
  shouldRenderSignIn,
  shouldRenderSignUp,
  loginHref = loginPath,
  signupHref = signupPath,
}: Props) => {
  const { getFullyQualifiedURL } = useUniversalNavContext();

  const signupPreintentEvent = () => {
    emitUserInteractionEvent({
      interaction_name: 'universalnav-signup',
      event_action: 'click',
      option_selected: 'Sign up',
    });
  };
  return (
    <Fragment>
      {shouldRenderSignIn && (
        <UniversalTopbarLink
          ariaControls={undefined}
          role="none"
          navigationItem={{
            variant: 'link',
            href: getFullyQualifiedURL(loginHref) || '',
            text: 'Log in',
          }}
          position="actions-menu"
        >
          Log in
        </UniversalTopbarLink>
      )}
      {shouldRenderSignUp && (
        <div css={Styles.signupButton} data-zds>
          <BrandButton
            href={signupHref}
            id="universalnav-signup"
            isFullWidth={true}
            onClick={signupPreintentEvent}
          >
            Sign up
          </BrandButton>
        </div>
      )}
    </Fragment>
  );
};

export default AccountActions;
